import { render, staticRenderFns } from "./Consideracao.vue?vue&type=template&id=7fcc1098&scoped=true&"
import script from "./Consideracao.vue?vue&type=script&lang=js&"
export * from "./Consideracao.vue?vue&type=script&lang=js&"
import style0 from "./Consideracao.vue?vue&type=style&index=0&id=7fcc1098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc1098",
  null
  
)

export default component.exports